import type { VFC } from 'react';
import { ValidationFailedError } from 'lib/services/validation-failed.error';
import { Modal } from 'components';
import { DEMO_ACCOUNT_FORM_ID, DemoAccountForm } from './Form';
import { useCreateDemoAccount } from './useCreate';

interface DemoAccountModalProps {
  onClose: () => void;
}

export const DemoAccountModal: VFC<DemoAccountModalProps> = ({ onClose }) => {
  const { mutate: createDemoAccount, isLoading: isCreating, error } = useCreateDemoAccount({ onSuccess: onClose });

  return (
    <Modal
      centered
      open
      confirmLoading={isCreating}
      okButtonProps={{
        htmlType: 'submit',
        form: DEMO_ACCOUNT_FORM_ID,
      }}
      title="Create demo account"
      onCancel={onClose}
    >
      <DemoAccountForm
        errors={error instanceof ValidationFailedError ? error.errors : []}
        onFinish={createDemoAccount}
      />
    </Modal>
  );
};
